import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteSelectionList } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function for deleting a Selection List.
 */
export const useDeleteSelectionList = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call deleteSelectionList.
     * @param {Pella.ProductionRequestAPI.SelectionList['id']} id - The ID of the Selection List to delete.
     */
    mutationFn: (id) => deleteSelectionList(id),
    onSuccess: () => {
      toast.dismiss();
      toast.success('Selection List deleted successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.SELECTION_LISTS] });
    },
  });
};
